import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { SEGMENTS_CONST, RISK_LEVELS } from '../../../shared/constants/rate.constants';
import { RequestService } from '../../../shared/services/request/request-onboarding.service';

@Component({
  selector: 'app-max-period-request',
  templateUrl: './max-period-request.component.html',
  styleUrls: ['./max-period-request.component.scss'],
})
export class MaxPeriodRequestComponent implements OnInit {
  formGroup: FormGroup;
  maxPeriod: any;
  taxRates: any;
  activeInput = false;
  showRate = false;
  readonly SEGMENTS_CONST = SEGMENTS_CONST;
  readonly RISK_LEVELS = RISK_LEVELS;

  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private parametersService: ParametersService,
    private requestService: RequestService,
    private helperService: HelpersService,
  ) {
    this.headerService.show(false, true, true);
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      maxPeriodValue: new FormControl(this.maxPeriod, [Validators.required, Validators.min(6), Validators.max(60)]),
    });
    this.getRates();
    if (this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue) {
      this.maxPeriod = this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
      this.formGroup.controls.maxPeriodValue.setValue(this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue);
    }
  }

  getRates() {
    this.requestService.getRatesFromServer().then((res: any) => {
      this.requestService.setRates(res.products[0].segments);
      this.taxRates = res.products[0].segments;
      this.showRate = true;
    }).catch(() => this.navigationService.navigateToGeneralInformation('127'));
  }

  reactiveInputChangeMaxPeriod() {
    const controlMaxPeriod = this.formGroup.controls['maxPeriodValue'] as FormControl;
    this.maxPeriod = controlMaxPeriod.value;
  }

  next() {
    this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue = this.maxPeriod;
    this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue = this.taxRates;
    this.navigationService.nextStep('200');
  }

}
